import React, { useEffect } from "react";
import { Stack } from "@mui/material";
import { useLocation } from "react-router-dom";

import { useGetWorkOrders, useWorkOrdersContext } from "../../hooks";
import { HubTableTemplate } from "../../components";

import { items, keys } from "./helper";
import { WorkOrderRoutingDataTable } from "../WorkOrderRoutingDataTable";
import WorkOrdersOrdersEmpty from "./WorkOrdersOrdersEmpty";

export const WorkOrdersParamsTable = ({ locationId = 1 }) => {
  const { data, refetch } = useGetWorkOrders({ locationId });

  const {
    onSelectAll = () => {},
    selectedAll,
    onClear = () => {},
  } = useWorkOrdersContext();

  const location = useLocation();

  useEffect(() => {
    refetch();
    onClear();
  }, [location?.search?.toString()]);

  const onSelectAllHelper = (e) => {
    const value = e?.target?.checked;
    const allIds = value ? data?.rows?.map(({ workOrder }) => workOrder) : [];
    const ids = new Set(allIds);
    onSelectAll(ids, value);
  };

  const headerProps = {
    items,
    includeCheckbox: true,
    onSelectAll: onSelectAllHelper,
    selectedAll,
  };
  const bodyProps = {
    items: data?.rows,
    keys,
    RenderElement: WorkOrderRoutingDataTable,
  };
  const props = {
    headerProps,
    bodyProps,
    meta: { ...data?.meta },
  };

  return !data?.rows?.length ? (
    <WorkOrdersOrdersEmpty />
  ) : (
    <Stack gap="10px" overflow="hidden">
      <HubTableTemplate id="WorkOrdersTable" {...props} showPagination />
    </Stack>
  );
};

export default WorkOrdersParamsTable;
